// ***************************************
// CardComponent
//
// This is an empty template for a new component
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 25-9-2015
// ***************************************
import { inviteFriendManager } from "../../../game_theme/flow_fb/flowController";
import { ComponentBase } from "../../framework/components/ComponentBase";
import { tgfComponents } from "../../framework/components/tgfComponents";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { CardSettings, NameSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { PhysicsObjectDefinition } from "../../settings/blocks";
import { DailyRewardManager } from "../DailyRewardManager";
import { SceneController } from "../SceneController";
import { playController } from "../gameController";
// Directives for jslint
/*global tbEase, tbVectorFont, tbGraphics, tbImage, tbSurface, tbGame */
/*global tgfComponents, tgfScale, tgfEffects, tgfDictionary, tgfAudio, tgfSettings */
tgfSettings.componentDefaults.cardComponent = {
    components: [] // Components to add as children
};
// The constructor for the component
/**
 * @constructor
 * @base ComponentBase
 */
export var CardComponent = function (properties) {
    "use strict";
    this.name = "CardComponent"; // The name of the component
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.cardComponent);
    // Set user properties
    this.cards = [];
    this.cardButtons = [];
    this.selectedCard = 0;
    for (var a in properties) {
        this[a] = properties[a];
    }
};
// Inherit the base component
tgfComponents.inherit(CardComponent, ComponentBase);
// ***************************************
// Specific methods for this component
// ***************************************
CardComponent.prototype.populateCards = function (roundForPull) {
    var birdOptions = JSON.parse(JSON.stringify(CardSettings.birdOptions));
    if (!DailyRewardManager.isTerenceActive()) {
        this._changeBirdChance(birdOptions, NameSettings.bigBird, 0);
    }
    if (DailyRewardManager.isFirstTerenceTurn()) {
        this._changeBirdChance(birdOptions, NameSettings.bigBird, 2000000000);
    }
    // Uncomment to reenable matilda invites
    // if (!inviteFriendManager.unlockBird()) {
    // 	this._changeBirdChance(birdOptions, NameSettings.matilda, 0);
    // }
    if (inviteFriendManager.isFirstMatildaTurn()) {
        this._changeBirdChance(birdOptions, NameSettings.matilda, 2000000000);
    }
    this.cards = SceneController.getRandomCards(roundForPull, birdOptions);
};
CardComponent.prototype._changeBirdChance = function (birdOptions, bird, chance) {
    for (var i = 0; i < birdOptions.length; i++) {
        var options = birdOptions[i].options;
        for (var j = 0; j < options.length; j++) {
            if (options[j].bird == bird) {
                options[j].chance = chance;
            }
        }
    }
};
CardComponent.prototype.getFirstCard = function () {
    return this.cards.length > 0 ? this.cards[0] : false;
};
CardComponent.prototype.discardSelection = function () {
    this.cards.splice(this.selectedCard, 1);
    this.selectedCard = 0;
    this.reAddCardUi();
};
CardComponent.prototype.reAddCardUi = function () {
    for (var a = 0; a < this.cardButtons.length; a++) {
        this.baseContainer.removeChild(this.cardButtons[a]);
    }
    this.cardButtons = [];
    if (this.cards.length === 0) {
        return;
    }
    for (var a = 0; a < this.selectedCard; a++) {
        this.createCard(a);
    }
    for (var a = this.cards.length - 1; a > this.selectedCard; a--) {
        this.createCard(a);
    }
    this.createCard(this.selectedCard);
};
CardComponent.prototype.createCard = function (index) {
    var _this = this;
    var birdToLoad = this.cards[index];
    var targetImage = PhysicsObjectDefinition[birdToLoad].cardImage;
    var cardScale = PhysicsObjectDefinition[birdToLoad].cardScale;
    var image = targetImage.clone();
    image.sprite.placeInStack = index;
    image.birdType = birdToLoad;
    image.animation = 0;
    image.animationVel = 0;
    image.setScale(cardScale.xCardScale, cardScale.yCardScale);
    image.setCallback(function () {
        if (!_this.isHoveringCard) {
            return;
        }
        if (_this.selectedCard !== image.sprite.placeInStack) {
            SoundManager.playEffect(SoundManager.BIRD_STATE.SELECT, PhysicsObjectDefinition[_this.cardButtons[image.sprite.placeInStack].birdType].sounds);
        }
        _this.selectedCard = image.sprite.placeInStack;
        playController.sceneController.selectBird(_this.cardButtons[_this.selectedCard].birdType);
        _this.reAddCardUi();
        _this.isHoveringCard = false;
    });
    image.setCallback(function () {
        _this.isHoveringCard = true;
    }, true);
    image.cancelCallback(function () {
        _this.isHoveringCard = false;
    });
    this.baseContainer.addChild(image);
    this.cardButtons[index] = image;
};
CardComponent.prototype.getCurrentBirdType = function () {
    return this.cardButtons[this.selectedCard].birdType;
};
// ***************************************
// Internal methods
// ***************************************
// ***************************************
// Preparing, showing and activating
//      - These can be removed if no processing is required
// ***************************************
// Processing required when preparing the component for use
CardComponent.prototype.doPrepare = function () {
    "use strict";
    var i;
    // Add the child components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
// ***************************************
// Methods called when events must be processed
//      - These can be removed when no processing is required
//      - When they return true, this event is no further processed
//          by other components in the dialog
//      - Never call these methods yourself in other components,
//          Use the inherited handle methods instead
// ***************************************
// Called at the beginning of each step
CardComponent.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    for (var a = 0; a < this.cardButtons.length; a++) {
        var card = this.cardButtons[a];
        var animationTarget = 0;
        if (a == this.selectedCard)
            animationTarget = 1;
        card.animation = card.animation + card.animationVel + 0.2 * (animationTarget - card.animation);
        card.animationVel += 0.05 * (animationTarget - card.animation);
        card.setRotation(-0.2 + a * 0.1);
        card.setPosition(110 * a + 70, tgfGraphics.areaHeight - (50 + 40 * card.animation));
        card.setDimensions(150 + 25 * card.animation, 210 + 25 * card.animation);
    }
};
// Called when a touch is started or if a mouse button is pressed
CardComponent.prototype.doTouchDown = function (finger, x, y) {
    "use strict";
};
// Called when a touch is ended or if a mouse button is released
CardComponent.prototype.doTouchUp = function (finger, x, y) {
    "use strict";
};
// Called when the position of the mouse wheel is changed
CardComponent.prototype.doMouseWheel = function (delta, x, y) {
    "use strict";
};
// Called immediately when a touch is started or if a mouse button is pressed
CardComponent.prototype.doImmediateTouchDown = function (finger, x, y) {
    "use strict";
};
// Called immediately when a touch is ended or if a mouse button is released
CardComponent.prototype.doImmediateTouchUp = function (finger, x, y) {
    "use strict";
};
// Called if the key with the given keyCode is pressed
CardComponent.prototype.doKeyDown = function (keyCode) {
    "use strict";
};
// Called if the key with the given keyCode is released
CardComponent.prototype.doKeyUp = function (keyCode) {
    "use strict";
};
// Called if a global alarm is reached
CardComponent.prototype.doAlarm = function (alarm) {
    "use strict";
};
// Called if a special or user-defined event happens
CardComponent.prototype.doSpecial = function (id, args) {
    "use strict";
};
// Called at the end of each step
CardComponent.prototype.doEndStep = function (timePassed) {
    "use strict";
};
// Called just before drawing (also when not active)
CardComponent.prototype.doUpdateVisuals = function (timePassed) {
    "use strict";
};
// Called when the component must be drawn (relative to position 0, 0)
CardComponent.prototype.doDraw = function () {
    "use strict";
};
// Called after drawing the sub-components
CardComponent.prototype.doEndDraw = function () {
    "use strict";
};
